// Copyright (c) 2016 Deere & Company

import BatteryClaimContainer from '../../claim/battery/state-connector';

export default {
    component: BatteryClaimContainer,
    name: 'BATTERY',
    path: 'battery/new(/:pin)'
};



// WEBPACK FOOTER //
// ./src/routes/claims/battery-claim-route.js